import { render, staticRenderFns } from "./TakeAnSpecialExam.vue?vue&type=template&id=47bb3aac"
import script from "./TakeAnSpecialExam.vue?vue&type=script&lang=js"
export * from "./TakeAnSpecialExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports